import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { UpdateCustomerWithdrawalPayload } from './customerWithdrawals.types';

export const updateCustomerWithdrawal = (client: AxiosInstance) => async (payload: UpdateCustomerWithdrawalPayload) => {
  return (
    await client.post<{ message: string; data: { categoryName: string; description: string; id: string } }>(
      API_ROUTES.UPDATE_CUSTOMER_WITHDRAWAL_DETAIL,
      payload,
    )
  ).data;
};

export const customerWithdrawalMutations = {
  updateCustomerWithdrawal,
};
